import styled from "styled-components";
import { DefaultButton } from "@ui/components/buttons/defaultButton";
import { mobile } from "@ui/styles/utils";

export const ViewBrochureButton = styled(DefaultButton)`
	background-color: ${({ theme }) => theme.colors.primary};
	color: ${({ theme }) => theme.colors.white};
	width: 100%;
	padding: 16px;
	transition: background-color 0.2s linear;
	:hover  {
		background-color: ${({ theme }) => theme.colors.primaryTouch};
	}
`;

export const ParticipateButton = styled(DefaultButton)`
	background-color: ${({ theme }) => theme.colors.white};
	border: solid 1px ${({ theme }) => theme.colors.primary};
	color: ${({ theme }) => theme.colors.primary};
	width: 100%;
	padding: 18px;
	transition: background-color 0.2s linear;
	:hover  {
		background-color: ${({ theme }) => theme.colors.lightergray};
	}
	@media ${mobile} {
		width: 100%;
	}
`;
